export default __webpack_public_path__ + "static/media/icons8-exit-48.d8e3a5b1.svg";